import { Administration } from "../../../listsSettings/administration";

export const allItems: string = `/${Administration.InternalName}/_lists/${Administration.Lists.Views.InternalName}/_pages/all_items`;
export const newForm: string = `/${Administration.InternalName}/_lists/${Administration.Lists.Views.InternalName}/_pages/new`;
export const dispForm: string = `/${Administration.InternalName}/_lists/${Administration.Lists.Views.InternalName}/_pages/disp`;
export const editForm: string = `/${Administration.InternalName}/_lists/${Administration.Lists.Views.InternalName}/_pages/edit`;
